import React from 'react';

const Footer = () => (
  <div>
    <footer className="px-5 md:px-20 lg:px-28 2xl:px-36 3xl:px-48 bg-black text-white dark:bg-gray-500 dark:text-gray-100 flex flex-row">
      <div className="space-x-1 py-4 md:py-3 text-sm md:text-base block self-center md:flex md:flex-row font-rubik font-bold">
        <span className="uppercase">
          &copy;
          {` ${new Date().getFullYear()} `} Techsico
        </span>
        . <div>All rights reserved.</div>
      </div>
      <div className="flex-grow" />
      <a
        href="https://www.techsicode.com/"
        target="_blank"
        rel="noopener noreferrer"
        className="py-6 px-5 md:py-3 uppercase text-sm md:text-base font-rubik font-bold self-center hover:bg-enterpriseOrange-500"
      >
        Employee Login
      </a>
    </footer>
  </div>
);

export default Footer;
